export const data = [
  {
    content: "Hey do you know Rita?",
    sprite: {
      x: 0.7,
      y: 1.8,
      z: -0.64
    },
    description: {
      x: 0.7,
      y: 1.8,
      z: -0.64
    }
  },
  {
    content: "You mean Rita, the 'happy Rita'? Rita, who always smiles, Rita? Rita, who always ready to help, Rita?",
    sprite: {
      x: 0.12,
      y: 2.08,
      z: 1.95
    },
    description: {
      x: 0.12,
      y: 2.08,
      z: 1.95
    }
  },
  {
    content: "Yeah! Sooo... LET'S MAKE HER LAUGH",
    sprite: {
      x: 1.2,
      y: 2.3,
      z: -1.2
    },
    description: {
      x: 1.2,
      y: 2.3,
      z: -1.2
    }
  },
  {
    content: "Sure thing! How?",
    sprite: {
      x: 0.12,
      y: 1.29,
      z: 3
    },
    description: {
      x: 0.12,
      y: 1.29,
      z: 3
    }
  },
  {
    content: "Type on your keyboard: 'RITA LOVES COLOURFUL CLOUDS'",
    sprite: {
      x: 1.8,
      y: 2.8,
      z: -1.3
    },
    description: {
      x: 1.8,
      y: 2.8,
      z: -1.3
    }
  },
  {
    content: "OK! Easy-peasy!",
    sprite: {
      x: 0.12,
      y: 2.59,
      z: 3.3
    },
    description: {
      x: 0.12,
      y: 2.59,
      z: 3.3
    }
  },
]